module.exports = {"us":"Amériques","eu":"Europe","cn":"Chine","tw":"Taïwan","kr":"Corée","world":"Monde"};